// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1uMp3","iframe":"styles_iframe__K4mLT"};